export const environment = {
  production: true,
  apiUrl: 'https://apiv2.ciboat.com/api/',
  webUrl: '',
  secret_key: 'cib948547987654321',
  mainLogo_arabic: 'assets/img/logos/cib-logo.png',
  mainLogo_english: 'assets/img/logos/cib-logo.png',
  mainLogo: 'assets/img/logos/cib-logo.png',
  headerLogo: 'assets/img/logos/cib-logo.png',
  secondaryLogo: 'assets/img/logos/cib-logo.png',
  favicon: 'assets/img/logos/cib-logo.png',
  socketUrl: '',
  supportEmail: '',
  currency: '',
};
